const UNILEVER_DOMAIN = "unilever.com"

/** Domain part of an email address, lowercased, or undefined when the address is malformed. */
export function emailDomain(email?: string | null): string | undefined {
    const parts = email?.trim().split("@")
    if (!parts || parts.length !== 2 || !parts[0] || !parts[1]) {
        return undefined
    }
    return parts[1].toLowerCase()
}

export function isUnileverEmail(email?: string | null): boolean {
    return emailDomain(email) === UNILEVER_DOMAIN
}
